import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    MemoryRouter,
    Link,
    Redirect
    // useHistory
} from "react-router-dom";
//import './Recharge.css';
import { clientInfo, transactionID } from "../../services/helpers";
import Menu from '../../Components/Menu';
import InicialPage from './inicialPage';
import StepNumber from './StepNumber';

import ChooseNumber from './ChooseNumber';
import ChooseAmount from './ChooseAmount';
import ChoosePayment from './ChoosePayment';
import RechargeResume from './RechargeResume';
import Swal from 'sweetalert2';
import axios from 'axios';

import Loading from '../../Components/Loading/Loading';


import withReactContent from "sweetalert2-react-content";
//import InputCVV from './InputCVV';

const MySwal = withReactContent(Swal);

class RechargeNew extends Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 0,
            confirmCvv: '',
            number: '',
            rechargeProgram: false,
            amount: {
                value: '',
                image: '',
                note: ''
            },
            payment: {
                id: '',
                flag: '',
                digFour: '',
                type: ''
            },
            loading: 0
        }
        

        this.sendRecharge = this.sendRecharge.bind(this);
    }

    step = (step) => {
        this.setState({step});
    } 

    setNumber = (number) => {
        this.setState({number});
    }

    setAmount = (amount) => {
        this.setState({amount});
    }

    setPayment = (payment) => {

        const paymentState = {
            id: payment.paymentID,
            flag: payment.flag,
            digFour: payment.digFour,
            type: payment.type
        }

        this.setState({payment: paymentState});
    }

    setLoading = (loading) => {
        this.setState({loading})
    }

    setRechargeProgram = (rechargeProgram) => {
        this.setState({rechargeProgram})
    }

    confirmCvv = async () => {

        const result = await MySwal.fire({
                title: 'Digite o CVV',
                input: 'text',
                inputAttributes: {
                    autocapitalize: 'off',
                    maxlength: 4,
                    type: 'number'
                },
                onOpen: (el) => {
                    el.addEventListener('keyup', function (e) {
                        e.target.value = e.target.value.toLocaleLowerCase().replace(/([a-z]+)/g, '');
                    });
                },
                showCancelButton: false,
                confirmButtonText: 'OK',

            });

            if (result.value > 0) {
                await this.setState({confirmCvv: result.value});
                this.sendRecharge()
            }
            return false;
    }

    componentDidMount = () => {

    }

    sendRecharge = async () => {

        try {

            const { amount, number, payment, confirmCvv, rechargeProgram} = this.state;

            if(confirmCvv === '') {
                this.confirmCvv();
                return false;

            }

            const response = await axios.post('https://www.pagtel.com.br/Hub360Correios/v2/recharge', {
                transactionId: transactionID('ACI'),
                MSISDN: clientInfo().number,
                SMSISDN: number,
                paymentType: payment.type,
                paymentId: payment.id,
                Value: amount.value,
                cvv: confirmCvv,
                program: rechargeProgram
            })
            
            

            switch (response.data.code) {
                case 'P00':
                    Swal.fire({
                        title: 'Sucesso',
                        text: "Sua recarga foi realizada com sucesso. Em alguns minutos seus créditos estarão disponíveis!",
                        type: 'success'
                    })

                    break;
                case 'D01':
                    window.location.href = response.data.authenticationUrl;
                    break;

                default:
                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error'
                    });

                    this.setState({ confirmCvv: '' })

                    break;
            }

        }catch(exception) {

            if(exception.response) {

                Swal.fire({
                    title: 'Erro!',
                    text: "Erro ao enviar a solicitação!",
                    type: 'error'
                })

            }
        }

       

    }
    

    render() {

        const {step, loading} = this.state;

        return (
            <div className="home">
                <Menu currBalance="" phone=""  />
                <div className="content-home">
                    <div className="top"></div>
                    
                    <div className="content-main content-recharge">

                        <div className="rechargeSteps">

                            {
                                step === 0 &&
                                <InicialPage step={this.step} />
                            }

                            {
                                step > 0 &&

                                <div >
                                    <StepNumber currentStep={step} step={this.step} resume={this.state} />

                                    {
                                        step === 1 &&
                                        <ChooseNumber setLoading={this.setLoading} step={this.step} setNumber={this.setNumber} />
                                    }

                                    {
                                        step === 2 &&
                                        <ChooseAmount setLoading={this.setLoading} step={this.step} setAmount={this.setAmount} />
                                    }

                                    {
                                        step === 3 &&
                                        <ChoosePayment setLoading={this.setLoading} step={this.step} setPayment={this.setPayment}  />
                                    }

                                    {
                                        step === 4 &&
                                        <RechargeResume setLoading={this.setLoading} sendRecharge={this.sendRecharge} setRechargeProgram={this.setRechargeProgram} step={this.step}  resume={this.state}  />
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {/* <Loading loading={loading} /> */}
            </div>
        );
    }

}

export default RechargeNew